import { message } from 'antd';
import { isEmpty } from 'lodash';
import common from '../../common';
import * as t from './actionTypes';
import globalappstate from '../globalappstate';
import companies from '../companies';


export function fetchStartupData() {
    return async (dispatch, getState) => {
        let currentuser = getState().currentuser;
        let lang = getState().uistate.appsettings.lang

        if (currentuser.idUser == 0) {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/Startup?lang=${lang}`)
            dispatch({
                type: t.STARTUP,
                payload: resp.data
            })

            const resp2 = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/Startup/picklists?lang=${lang}`)
            dispatch({
                type: globalappstate.actionTypes.LOAD_PICKLISTS,
                payload: resp2.data
            })

            const resp3 = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/Startup/counters`);
            dispatch({
                type: t.COUNTERS,
                payload: resp3.data
            })
        };
    }
}

export function loadUserCounters() {
    return async (dispatch, getState) => {
        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/Startup/counters`);
        dispatch({
            type: t.COUNTERS,
            payload: resp.data
        })
    };
}
